import { render } from "./PrintBatch.vue?vue&type=template&id=afccb1c8&scoped=true"
import script from "./PrintBatch.vue?vue&type=script&lang=js"
export * from "./PrintBatch.vue?vue&type=script&lang=js"

import "./PrintBatch.vue?vue&type=style&index=0&id=afccb1c8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afccb1c8"]])

export default __exports__